export default {
    events (state) {
      return state.events
    },
    getDemoEvent (state) {
      return state.demoEvent
    },
    getEmailTemplate (state) {
      return state.emailTemplate
    },
    selectedEvent (state) {
        return state.selectedEvent
    },
    getEvent: state => (eventId) => {
      return state.events.find(event => event.eventId === eventId)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/events/getters.js